<template>
	<div class="common-layout">
		<el-container>
			<el-aside width="250px" class="border-r-2">
				<div class="mt-5 px-4 py-6 rounded-lg">
					<i class="pi pi-file mb-4" style="font-size: 3rem"></i>
					<h2 class="title-font font-medium text-2xl text-gray-900">
						關鍵能力問卷
					</h2>
					<p class="leading-relaxed">Questionnaire</p>
				</div>
				<ul>
					<li class="w-full">
						<a
							@click="goToRecordsAndExport"
							class="adminLink text-lg inline-block p-4 w-full hover:text-gray-70 rounded-r-lg hover:bg-gray-200 focus:ring-4 focus:ring-blue-300 focus:outline-none"
						>
							紀錄 & 匯出
						</a>
					</li>
                    <li class="w-full">
						<a
							@click="goToSetting"
							class="adminLink text-lg inline-block p-4 w-full bg-gray-100 hover:text-gray-70 rounded-r-lg hover:bg-gray-200 focus:ring-4 focus:ring-blue-300 focus:outline-none"
						>
							問卷設定
						</a>
					</li>
					<li class="w-full">
						<a
							@click="goBack"
							class="adminLink text-lg inline-block p-4 w-full hover:text-gray-70 rounded-r-lg hover:bg-gray-200 focus:ring-4 focus:ring-blue-300 focus:outline-none"
						>
							返回上一頁
						</a>
					</li>
				</ul>
			</el-aside>

			<el-main>
				<section>
					<div
						class="border rounded-lg text-white p-5 m-5 text-left"
						style="background-color: #2db3b3"
					>
						<div class="widget widget-info flex" style="padding-bottom: 0">
							<h3 class="widget-title">問卷開放設定</h3>
						</div>

						<div class="grid gap-6 p-5 lg:grid-cols-2">
							<div>
								<label
									for="semester"
									class="block mb-2 text-md font-medium text-white-900"
								>
									<span style="color: red"> * </span>開放學期
								</label>
								<div class="flex items-center gap-2">
									<div
										class="bg-gray-50 border border-gray-300 text-gray-900 text-md rounded-lg block p-2.5"
									>
										<InputText
											id="semester"
											v-model="semesterYear"
											class="w-24 text-center"
											placeholder="例如 114"
											maxlength="3"
											inputmode="numeric"
											@input="normalizeSemesterYear()"
										/>
									</div>
									<span class="text-white">-</span>
									<div
										class="bg-gray-50 border border-gray-300 text-gray-900 text-md rounded-lg block p-2.5"
									>
										<InputText
											v-model="semesterTerm"
											class="w-16 text-center"
											placeholder="2"
											maxlength="1"
											inputmode="numeric"
											@input="normalizeSemesterTerm()"
										/>
									</div>
								</div>
							</div>
							<div class="flex items-end">
								<div
									class="bg-gray-50 border border-gray-300 text-gray-900 text-md rounded-lg block w-full p-2.5"
								>
									<div class="flex items-center gap-2">
										<Checkbox
											v-model="settingForm.is_active"
											:binary="true"
											inputId="forceOpen"
										/>
										<label for="forceOpen" class="cursor-pointer">
											測試開放（忽略日期可填寫）
										</label>
									</div>
								</div>
							</div>
						</div>

						<div class="grid grid-cols-1 gap-3 mb-6 p-5 pt-0 lg:grid-cols-2">
							<div>
								<label
									for="openDate"
									class="block mb-2 text-md font-medium text-white-900"
								>
									<span style="color: red"> * </span>開放日期
								</label>
								<div
									class="date-input-wrap"
								>
									<div
									class="bg-gray-50 border border-gray-300 text-gray-900 text-md rounded-lg block w-full p-2.5"
									>
										<Calendar
											v-model="settingForm.form_open_date"
											inputId="openDate"
											:showIcon="true"
											:showTime="true"
											hourFormat="24"
											dateFormat="yy-mm-dd"
											class="w-full setting-date-input"
										/>
									</div>
									<button
										v-if="settingForm.form_open_date"
										type="button"
										class="date-clear-btn"
										@click.stop="settingForm.form_open_date = null"
									>
										×
									</button>
								</div>
							</div>
							<div>
								<label
									for="closeDate"
									class="block mb-2 text-md font-medium text-white-900"
								>
									<span style="color: red"> * </span>關閉日期
								</label>
								<div
									class="date-input-wrap"
								>
									<div
									class="bg-gray-50 border border-gray-300 text-gray-900 text-md rounded-lg block w-full p-2.5"
									>
										<Calendar
											v-model="settingForm.form_close_date"
											inputId="closeDate"
											:showIcon="true"
											:showTime="true"
											hourFormat="24"
											dateFormat="yy-mm-dd"
											class="w-full setting-date-input"
										/>
									</div>
									<button
										v-if="settingForm.form_close_date"
										type="button"
										class="date-clear-btn"
										@click.stop="settingForm.form_close_date = null"
									>
										×
									</button>
								</div>
							</div>
						</div>

						<div class="p-5 pt-0 text-center">
							<button
								type="button"
								class="text-white px-10 py-3 rounded-lg"
								style="background-color: #1e8f8f"
								:disabled="isSaving"
								@click="saveSetting"
							>
								{{ isSaving ? "儲存中..." : "儲存設定" }}
							</button>
						</div>
					</div>
				</section>
			</el-main>
		</el-container>
	</div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import Checkbox from "primevue/checkbox";
import { ElNotification } from "element-plus";

export default {
	components: {
		Calendar,
		InputText,
		Checkbox,
	},
	setup() {
		const router = useRouter();

		const settingForm = ref({
			id: null,
			semester: "",
			form_open_date: null,
			form_close_date: null,
			is_active: false,
		});
		const semesterYear = ref("");
		const semesterTerm = ref("");
		const originalSemester = ref("");
		const isSaving = ref(false);

		const goBack = () => {
			router.push({ path: "/sladmin" });
		};

		const goToSetting = () => {
			router.push({ path: "/sladmin/questionnaire-setting" });
		};

		const goToRecordsAndExport = () => {
			router.push({ path: "/sladmin/questionnaire" });
		};

		const parseServerDate = (value) => {
			if (!value) {
				return null;
			}

			if (value instanceof Date) {
				return value;
			}

			if (typeof value === "string") {
				if (value.includes("T")) {
					return new Date(value);
				}
				return new Date(value.replace(" ", "T") + "+08:00");
			}

			return new Date(value);
		};

		const formatDateTime = (value) => {
			if (!value) {
				return "";
			}

			const date = value instanceof Date ? value : new Date(value);
			if (Number.isNaN(date.getTime())) {
				return "";
			}

			const pad = (number) => String(number).padStart(2, "0");
			const year = date.getFullYear();
			const month = pad(date.getMonth() + 1);
			const day = pad(date.getDate());
			const hour = pad(date.getHours());
			const minute = pad(date.getMinutes());
			const second = pad(date.getSeconds());

			return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
		};

		const fetchSetting = async () => {
			try {
				const response = await axios.get(
					process.env.VUE_APP_api_url + "/questionnaire/ability/status"
				);

				if (response.data && response.data.status === true && response.data.data) {
					const data = response.data.data;
					settingForm.value = {
						id: data.id ?? null,
						semester: data.semester || "",
						form_open_date: parseServerDate(data.form_open_date),
						form_close_date: parseServerDate(data.form_close_date),
						is_active: Boolean(data.is_active),
					};
					const [yearPart, termPart] = String(data.semester || "").split("-");
					semesterYear.value = yearPart || "";
					semesterTerm.value = termPart || "";
					originalSemester.value = data.semester || "";
				}
			} catch (error) {
				console.error("取得問卷設定失敗:", error);
				ElNotification({
					title: "錯誤",
					message: "無法載入問卷設定",
					type: "error",
				});
			}
		};

		const saveSetting = async () => {
			if (isSaving.value) {
				return;
			}

			const normalizedYear = semesterYear.value.trim();
			const normalizedTerm = semesterTerm.value.trim();
			if (!/^\d{3}$/.test(normalizedYear) || !/^[12]$/.test(normalizedTerm)) {
				ElNotification({
					title: "提醒",
					message: "開放學期請填三位數年份與 1 或 2",
					type: "warning",
				});
				return;
			}

			if (!settingForm.value.form_open_date || !settingForm.value.form_close_date) {
				ElNotification({
					title: "提醒",
					message: "請選擇開放與關閉日期",
					type: "warning",
				});
				return;
			}

			isSaving.value = true;
			try {
				const semesterValue = `${normalizedYear}-${normalizedTerm}`;
				if (originalSemester.value && semesterValue !== originalSemester.value) {
					const confirmed = window.confirm(
						"開放學期將變更，是否確定送出？"
					);
					if (!confirmed) {
						const [yearPart, termPart] = String(originalSemester.value).split("-");
						semesterYear.value = yearPart || "";
						semesterTerm.value = termPart || "";
						isSaving.value = false;
						return;
					}
				}
				const payload = {
					id: settingForm.value.id,
					semester: semesterValue,
					form_open_date: formatDateTime(settingForm.value.form_open_date),
					form_close_date: formatDateTime(settingForm.value.form_close_date),
					is_active: settingForm.value.is_active,
				};

				const response = await axios.post(
					process.env.VUE_APP_api_url + "/questionnaire/ability/setting",
					payload
				);

				if (response.data && response.data.status === true) {
					ElNotification({
						title: "成功",
						message: "問卷設定已更新",
						type: "success",
					});
					settingForm.value.semester = semesterValue;
					originalSemester.value = semesterValue;
					await fetchSetting();
				} else {
					throw new Error(response.data?.message || "更新失敗");
				}
			} catch (error) {
				console.error("更新問卷設定失敗:", error);
				ElNotification({
					title: "錯誤",
					message: error.message || "更新問卷設定失敗",
					type: "error",
				});
			} finally {
				isSaving.value = false;
			}
		};

		const normalizeSemesterYear = () => {
			semesterYear.value = semesterYear.value
				.replace(/\D/g, "")
				.slice(0, 3);
		};

		const normalizeSemesterTerm = () => {
			semesterTerm.value = semesterTerm.value
				.replace(/\D/g, "")
				.slice(0, 1);
			if (semesterTerm.value && !["1", "2"].includes(semesterTerm.value)) {
				semesterTerm.value = "";
			}
		};

		onMounted(() => {
			fetchSetting();
		});

		return {
			settingForm,
			semesterYear,
			semesterTerm,
			isSaving,
			goBack,
			goToSetting,
			goToRecordsAndExport,
			saveSetting,
			normalizeSemesterYear,
			normalizeSemesterTerm,
		};
	},
};
</script>

<style scoped>
:deep(.date-input-wrap) {
	position: relative;
}

:deep(.date-clear-btn) {
	position: absolute;
	right: 3.45rem;
	top: 50%;
	transform: translateY(-50%);
	width: 1.3rem;
	height: 1.3rem;
	border-radius: 9999px;
	border: none;
	background: #e5e7eb;
	color: #374151;
	font-size: 1rem;
	line-height: 1;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
}

:deep(.date-clear-btn:hover) {
	background: #d1d5db;
}

:deep(.setting-date-input .p-inputtext) {
	padding-right: 5.6rem;
}
</style>
